import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";
import './i18n'; // Import i18n configuration
import { HelmetProvider } from 'react-helmet-async';
import { initSentry, SentryErrorBoundary } from './utils/sentry';

// Auth now lives in httpOnly cookies — always send credentials.
axios.defaults.withCredentials = true;

// Google Translate (and similar extensions) wrap text nodes in <font> tags,
// which breaks React's DOM reconciliation (NotFoundError: removeChild /
// insertBefore). Known workaround from facebook/react#11538 — fail soft
// instead of crashing the whole tree.
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child, ...rest) {
    if (child.parentNode !== this) {
      return child;
    }
    return originalRemoveChild.apply(this, [child, ...rest]);
  };
  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode, ...rest) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return originalInsertBefore.apply(this, [newNode, null, ...rest]);
    }
    return originalInsertBefore.apply(this, [newNode, referenceNode, ...rest]);
  };
}

initSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <SentryErrorBoundary>
        <HelmetProvider>
          <App />
        </HelmetProvider>
    </SentryErrorBoundary>
  </React.StrictMode>,
);
